export default {
	methods: {
		getProductAttribute(product, attribute) {
			const p = product.property.find(p => p._name === attribute)

			if (!p) {
				return null
			}
			return p['#text']
		},
	}
}
